import atmoClient from "@/setup/clients/atmoClient";
import RestClient from "@/api/utils/baseRestClient";

export const phaseRestClient = new RestClient(atmoClient, "phases");
